import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ComponentDefinition } from '@formbird/types';
import { FormbirdInjectorService } from '../../../../formbird-services/src/lib/services/injector/formbird-injector.service';
import { Validators } from '@angular/forms';
import { ChangedDocumentService } from 'formbird-services';
import { ComponentSetupService } from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import { AbstractComponent } from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField } from '@angular/material/form-field';

interface PhoneNumberComponentDefinition extends ComponentDefinition {
  min?: number;
  max?: number;
  step?: number;
  precision?: number;
  valueLabel?: string;
}

@Component({
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneNumberComponent extends AbstractComponent<PhoneNumberComponentDefinition> implements OnInit {

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    protected cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);
  }

  ngOnInit() {
    super.ngOnInit();
    this.validators = [];

    if (this.componentDefinition.mandatory === true) {
      this.validators.push(Validators.required);
    }

    this.formControl.setValidators(this.validators);
    this.formControl.updateValueAndValidity({ emitEvent: false, onlySelf: true });

     this.setFieldActivation(true);
  }

  protected onControlValueChanged(value) {
    // 20720 ensure validation is detected
    if (value === undefined || value === '') {
      super.onControlValueChanged(undefined);
    }
    const trimedValue = value.trimEnd();
    const hasNumber = /[0-9]/.test(trimedValue);
    if (hasNumber) {
      super.onControlValueChanged(trimedValue);
    }
  }

  cleanPastedValue(event: ClipboardEvent) {
    const pastedText = event.clipboardData.getData('text');
    // Replace non-numerals (except +) with spaces
    let cleaned = pastedText.replace(/[^\d+\s]/g, '');

    // Replace consecutive spaces with a single space
    cleaned = cleaned.replace(/\s{2,}/g, ' ');

    // Remove any '+' that is not the first character
    cleaned = cleaned.replace(/(?!^)\+/g, '');

    // Trim any space which is first character
    cleaned = cleaned.replace(/^\s+/, '');

    // Truncate to at most 20 characters
    if (cleaned.length > 20) {
      cleaned = cleaned.slice(0, 20).trim();
    }

    const currentValue = this.formControl.value || '';

    const cursorPosition = (event.target as HTMLInputElement).selectionStart;

    // Merge cleaned text with existing text at cursor position
    const newValue = currentValue.slice(0, cursorPosition) + cleaned + currentValue.slice(cursorPosition);

    // Truncate if necessary
    const finalValue = newValue.length > 20 ? newValue.slice(0, 20).trim() : newValue;

    this.formControl.setValue(finalValue);
    event.preventDefault();
   }

   validatePhoneNumber(event: KeyboardEvent): void {
    const key = event.key;
    const currentValue = this.formControl.value;

     if (event.ctrlKey || event.metaKey) {
      return;
    }

    // Prevent invalid characters
    let isValidCharacter = true;
    if(key.length === 1){
       isValidCharacter = /^[0-9\s\+]$/.test(key);
    }

    if (!isValidCharacter) {
      event.preventDefault();
    }

    // Allow + only as the first character not middle
    if (key === '+') {
      if (currentValue?.length > 0 && currentValue.length <20) {
        const newPhoneNumValue = '+'+currentValue.replace(/\+/g, '').trim();
        this.formControl.setValue(newPhoneNumValue);
        const fieldElem = (event.target as HTMLInputElement);
        fieldElem.setSelectionRange(fieldElem.selectionStart, fieldElem.selectionEnd);
      }
      if (currentValue && currentValue.length !== 0) {
        event.preventDefault();
      }
    }

    if (key === ' ') {
      // prevent having space as the first character
      if (!currentValue) {
        event.preventDefault();
      }
      // Prevent two consecutive spaces
      if (currentValue && currentValue.slice(-1) === ' ') {
        event.preventDefault();
      }
    }

    // Enforce maximum length of 20 characters
    if (currentValue && currentValue.length >= 20) {
      if ((key === 'Backspace')|| (key === 'Delete') || (key === 'Tab') ||
        (key === 'ArrowRight') || (key === 'ArrowLeft') || (key === 'ArrowUp') ||
        (key === 'Home') || (key === 'End')) {
        return;
      }else{
        event.preventDefault();
      }
    }
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth;
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
